import React, {useState, useEffect} from "react";
import { useSnackbar } from '../../../../context/snackbar-context';
import request from "../../../../util/SuperagentUtils";
import { adminBookingsReportEndpoints } from "../../../../requests/api-endpoints";
import { ReportDialogProps } from "../../../../interfaces";
import { AdminBookingReportVO } from "../../../../types/model/valueObject/booking/AdminBookingReportVO";
import { Dialog, DialogActions, DialogTitle, DialogContent, FormControl, Button, SelectChangeEvent } from "@mui/material";
import { getRecurringProperties } from "../../../../util/BookingUtil";
import moment from "moment";
import SelectInput from "../../../SelectInput";
import { SelectInputProps } from "../../../../hooks/report/useGetOptions";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../../../util/NetworkErrorUtil";

const cannedMessages = {
  genericError: 'Unable to adjust end date on booking. Please contact support.',
  success: (orderNumber: string) => `Successfully adjusted end date on booking ${orderNumber}`
};

const AdjustEndDateDialog = ({
  item,
  open,
  onClose
}: ReportDialogProps<AdminBookingReportVO>) => {
  const { snackbarShowMessage } = useSnackbar();

  const [newEndDate, setNewEndDate] = useState<SelectInputProps | undefined>(undefined);
  const [dateSelectOptions, setDateSelectOptions] = useState<SelectInputProps[]>([]);

  const submitForm = () => {
    if (!item || !newEndDate?.value) {
      snackbarShowMessage(cannedMessages.genericError, 'error');
      onClose({item, action: 'ERROR'});
      return;
    }
    request.post(adminBookingsReportEndpoints.actions.adjustEndDate)
      .send({bookingId: item.id, endDate: moment(newEndDate.value).format('M/DD/YYYY')})
      .then(() => {
          snackbarShowMessage(cannedMessages.success(item.orderNumber), 'success');
          onClose({item, action: 'SUCCESS'});
      }).catch((err: any) => snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(err), 'error'));
  };

  const handleSelectNewEndDate = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setNewEndDate(dateSelectOptions.find(item => item.value === value));
  };

  useEffect(() => {
    if (item) {
      setDateSelectOptions(getRecurringProperties(item.durationType, item.startDate));
    }
  }, [item]);

  return (
    <Dialog open={open}>
      <DialogTitle>Adjust End Date for {item?.orderNumber}</DialogTitle>

      <DialogContent>
        <FormControl variant="standard" fullWidth>
          <SelectInput
            label="End Date"
            value={newEndDate?.value}
            onChange={handleSelectNewEndDate}
            selectData={dateSelectOptions}
            hasAction={false}
          />
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" onClick={submitForm}>
          ADJUST
        </Button>
        <Button color="primary" onClick={() => onClose({ item })}>
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AdjustEndDateDialog };